import React from 'react'

import AdminLayout from '../components/AdminLayout'

import './monitoring.css'

const Monitoring = () => {
  return (
    <AdminLayout
      title="Real Time Monitoring"
      activeNav="monitoring"
      pageTitle="Real Time Monitoring - Namami Gange"
    >
      <div className="monitoring-grid-top">
        <div className="admin-stat-card">
          <h3>Plant Status</h3>
          <div className="admin-stat-value monitoring-stat-running">Running</div>
          <div className="admin-stat-sub">All system normal</div>
        </div>
        <div className="admin-stat-card">
          <h3>Total Units</h3>
          <div className="admin-stat-value">12</div>
          <div className="admin-stat-sub">Operating</div>
        </div>
        <div className="admin-stat-card">
          <h3>Active Alarms</h3>
          <div className="admin-stat-value monitoring-stat-alarm">3</div>
          <button type="button" className="monitoring-link">
            View Alarms
          </button>
        </div>
        <div className="admin-stat-card">
          <h3>Uptime (Today)</h3>
          <div className="admin-stat-value">98.5%</div>
          <div className="admin-stat-sub">Since 12:00 AM</div>
        </div>
      </div>

      <div className="monitoring-mid">
        <div className="admin-panel">
          <h2>Live Parameter Overview</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Unit</th>
                  <th>Current Value</th>
                  <th>Status</th>
                  <th>Trend</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Inlet Flow', 'm³/hr', '1,250', 'Normal'],
                  ['Outlet Flow', 'm³/hr', '1,180', 'Normal'],
                  ['pH Level', '—', '7.2', 'Normal'],
                  ['Power Consumption', 'kW', '245', 'Normal'],
                ].map(([p, u, v, s]) => (
                  <tr key={p}>
                    <td>{p}</td>
                    <td>{u}</td>
                    <td>{v}</td>
                    <td>
                      <span className="admin-pill">{s}</span>
                    </td>
                    <td>—</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="admin-panel">
          <h2>Plant Map</h2>
          <div className="monitoring-flow">
            <div className="monitoring-flow-node">Inlet</div>
            <span className="monitoring-flow-arrow">→</span>
            <div className="monitoring-flow-node">Inlet Pump</div>
            <span className="monitoring-flow-arrow">→</span>
            <div className="monitoring-flow-node">Reactor</div>
            <span className="monitoring-flow-arrow">→</span>
            <div className="monitoring-flow-node">Clarifier</div>
            <span className="monitoring-flow-arrow">→</span>
            <div className="monitoring-flow-node">Outlet</div>
          </div>
          <div className="monitoring-flow-status">
            <span>
              <span className="monitoring-flow-dot" />
              Inlet Pump · Running
            </span>
            <span>
              <span className="monitoring-flow-dot" />
              Reactor · Running
            </span>
            <span>
              <span className="monitoring-flow-dot" />
              Clarifier · Running
            </span>
          </div>
        </div>
      </div>

      <div className="monitoring-bottom">
        <div className="admin-panel">
          <h2>Recent Alarms</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Alarm</th>
                  <th>Area</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>10:35 AM</td>
                  <td>High pH Level</td>
                  <td>Reactor</td>
                  <td>
                    <span className="admin-pill">Active</span>
                  </td>
                </tr>
                <tr>
                  <td>10:20 AM</td>
                  <td>Low Inlet Flow</td>
                  <td>Inlet Pump</td>
                  <td>
                    <span className="admin-pill">Active</span>
                  </td>
                </tr>
                <tr>
                  <td>09:50 AM</td>
                  <td>Power Fluctuation</td>
                  <td>Electrical Panel</td>
                  <td>
                    <span className="admin-pill admin-pill--muted">Acknowledged</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="admin-panel">
          <h2>Quick Actions</h2>
          <div className="monitoring-actions">
            <button type="button" className="monitoring-action-tile monitoring-action-tile--a">
              Process Overview
            </button>
            <button type="button" className="monitoring-action-tile monitoring-action-tile--b">
              Acknowledge Alarm
            </button>
            <button type="button" className="monitoring-action-tile monitoring-action-tile--c">
              Generate Report
            </button>
            <button type="button" className="monitoring-action-tile monitoring-action-tile--d">
              Settings
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}

export default Monitoring
